import moment from 'moment';
import { DateFormatStrings } from './constants';

/**
 * Format a Date object to MM-DD-YYYY string format
 * @param date - Date object to format
 * @returns formatted date string in MM-DD-YYYY format
 */
export function formatDateMMDDYYYY(date: Date): string {
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
}

export const todayDate = new Date();

export const todayDateString = formatDateMMDDYYYY(todayDate);

export const formatToHHMM = (date: Date): string => {
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  return `${hours}:${minutes} ${ampm}`;
};

// Convert UTC string or Date to local date string
export const utcToLocalDateString = (utcDate: string | Date): string => {
  const date = new Date(utcDate);
  return date.toLocaleDateString(); // local date only as string
};

// Convert UTC string or Date to local Date object
export const utcToLocalDate = (utcDate: string | Date): Date => {
  return new Date(utcDate); // JS Date object auto converts to local time internally
};

// Convert local Date object to UTC ISO string
export const localDateToUTCString = (localDate: Date | string): string => {
  if (typeof localDate === 'string') {
    localDate = new Date(localDate);
  }
  return localDate.toISOString(); // UTC ISO string format
};

// Convert local Date object to UTC Date object
export const localDateToUTCDate = (localDate: Date): Date => {
  return new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
};

//Convert UTC Date object to local Date object
export const utcDateToLocalDate = (utcDate: Date): Date => {
  return new Date(utcDate.getTime());
};

export const convertUtcToLocal = (
  utcTimeString: string | Date,
  outputFormat = DateFormatStrings.DD_MMMM_YYYY_h_mm_A,
): string => {
  if (!utcTimeString) {
    return '';
  }
  return moment.utc(utcTimeString).local().format(outputFormat);
};

export const getDeviceTimeZone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;
